// Takes a non-empty string and returns it with the first letter uppercased
// Empty strings returns empty string
export const capitalize = (str: string): string => {
  if (str.length === 0) return str;

  return str[0].toUpperCase().concat(str.slice(1));
};
